import { PageHeader, Space } from "antd";
import { AuditProvider } from "../contexts/audit-context";
import tr from "../i18n";

export default function Audit2() {
  return (
    <PageHeader
      extra={
        <Space>
          <AuditProvider.GardensSelect />
          <AuditProvider.UsersSelect />
        </Space>
      }
      title={tr("Audit Logs")}
    >
      <AuditProvider.Table />
    </PageHeader>
  );
}
